module.exports = __webpack_public_path__ + "static/img/AT.3f288adb.jpg";